const earlyWarning = {
  queryList: [
    {
      name: 'unitName',
      label: '学校名称',
      component: 'select',
      request: {
        method: 'fetch',
        addr: '/school/school/querySchoolList',
        data: {keyWord: ''},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'academyName',
      label: '院系名称',
      component: 'input'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'secondSubjectName',
      label: '二级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confSecondSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    }
  ],
  urlMap: {
    select: '/paper/paperBaseInfo/queryUnReviewInfo',
    urgeExpert: '/exp/expReviewInfo/warnMsgToExp',
    urgeUnit: '/exp/expReviewInfo/warnMsgToOffice'
  },
  operList: [// 操作列表
    {
      name: 'sendUrgeUnit',
      label: '发送单位催评短信',
      show: true,
      action: {
        type: 'request',
        addr: 'urgeUnit',
        data: '{searchParam}'
      }
    },
    {
      name: 'sendUrgeExpert',
      label: '发送专家催评短信',
      show: true,
      action: {
        type: 'request',
        addr: 'urgeExpert',
        data: '{searchParam}'
      }
    }
  ],
  titles: [
    {
      name: 'unitName',
      label: '学校名称'
    },
    {
      name: 'academyName',
      label: '院系名称'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      label: '二级学科'
    },
    {
      name: 'titleCn',
      label: '论文题目'
    },
    {
      name: 'rate',
      label: '接收情况',
      width: 100
    },
    {
      name: 'reviewNum',
      label: '提交情况',
      width: 100
    },
    {
      name: 'unit/expert',
      label: '预警单位/专家',
      width: 120,
      actionList: [{
        label: '查看',
        kind: 'primary',
        type: 'dialog',
        title: '预警单位/专家',
        footerHide: true,
        addr: 'thesisManage/relatedReview?{id}'
      }]
    }
  ]
}
export default earlyWarning



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/earlyWarning.js